import { observer } from 'mobx-react-lite'
import { ServiceTypeInfoDialog } from './'
import { serviceTypeInfoContentMap } from './service-type-info-content'
import type { DashboardViewModel } from '@/features/dashboard/DashboardView/DashboardViewModel'
import { useTranslate } from '@/hooks/translate'

interface ServiceTypeInfoDialogContainerProps {
  vm: DashboardViewModel
}

export const ServiceTypeInfoDialogContainer = observer(
  function ServiceTypeInfoDialogContainer({
    vm,
  }: ServiceTypeInfoDialogContainerProps) {
    const T = useTranslate()
    const startButtonLabel = T('Web.Dashboard.StartNowButton', 'Start now')
    const serviceType = vm.serviceSelectionVm.selectedServiceTypeForInfo
    if (!serviceType) {
      return null
    }

    const content = serviceTypeInfoContentMap[serviceType]

    return (
      <ServiceTypeInfoDialog
        isOpen={vm.serviceSelectionVm.serviceTypeInfoModalVm.showing}
        displayTitle={content.displayTitle}
        icon={content.icon}
        middleCard={content.middleCard}
        firstCard={content.firstCard}
        lastCard={content.lastCard}
        onClose={vm.serviceSelectionVm.serviceTypeInfoModalVm.close}
        onStartNow={vm.handleServiceTypeInfoStart}
        testId="service-type-info-dialog"
        startButtonLabel={startButtonLabel}
      />
    )
  },
)
